// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeoLandingDetailPage-module__wrapper","heading":"SeoLandingDetailPage-module__heading","content":"SeoLandingDetailPage-module__content"};